/**
 * Maximum number of characters of a single string written to the log.
 * Base64 photo payloads run into the megabytes, logging those in full drowns out
 * every other entry in the native console.
 */
export const MAX_LOGGED_STRING_LENGTH = 200;
